// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"styles_SignUp__3rfOT","signupContainer":"styles_signupContainer__9vC8M","error":"styles_error__1TVRM","loginLink":"styles_loginLink__2VYy-"};